// 封装转化时间格式的函数,js时间戳转化成日期格式
export function parseDateTime(dateTimeString) {
    // 创建一个Date对象
    const date = new Date(dateTimeString);

    // 获取 UTC 时间
    const utcTime = date.getTime();

    // 计算 CST 时间（UTC+8）
    const cstTime = utcTime + (8 * 60 * 60 * 1000); // 加上 8 小时

    // 创建一个新的 Date 对象用于 CST 时间
    const cstDate = new Date(cstTime);

    // 格式化 CST 时间
    const year = cstDate.getFullYear();
    const month = ('0' + (cstDate.getMonth() + 1)).slice(-2); // 月份从 0 开始，所以加 1
    const day = ('0' + cstDate.getDate()).slice(-2);
    const hours = ('0' + cstDate.getHours()).slice(-2);
    const minutes = ('0' + cstDate.getMinutes()).slice(-2);
    const seconds = ('0' + cstDate.getSeconds()).slice(-2);

    // 返回结果
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
}